
import { defineComponent } from "vue";
import StoreLocatorFilters from "@/components/StoreLocator/StoreLocatorFilters.vue";
import StoreLocatorMap from "@/components/StoreLocator/StoreLocatorMap.vue";
import BecomeDealerButton from "@/components/StoreLocator/BecomeDealerButton.vue";

export default defineComponent({
  name: "StoreLocator",
  components: {
    StoreLocatorFilters,
    StoreLocatorMap,
    BecomeDealerButton,
  },
  setup() {
    return {};
  },
});
